<script setup>
import PageHeader from './components/PageHeader.vue';
import { useRoute } from 'vue-router';
import { useRouteLoadingStore } from './stores/routeLoading';

const route = useRoute();
const routeLoadingStore = useRouteLoadingStore();
</script>

<template>
  <div class="flex! flex-col! lg:pb-15!">
    <PageHeader :linked="route.path !== '/'" />

    <!--
      router-view stays mounted (rather than being swapped out while
      loading) because it's the entering route's own onMounted that calls
      routeLoadingStore.stop() once its data is ready; the overlay just sits
      on top of it in the meantime.
    -->
    <div
      v-if="routeLoadingStore.isLoading"
      class="fixed! inset-0! z-[100]! flex! items-center! justify-center! bg-light-blue-2!"
    >
      <span class="w-12! h-12! border-4! border-blue! border-t-transparent! rounded-full! animate-spin!"></span>
    </div>

    <router-view />
  </div>
</template>
